define('modules/start/products/view',['require','exports','module','views/BaseView','./headers/active/view','env','ldsh!./template'],function (require, exports, module) {
  "use strict";

  var BaseView = require('views/BaseView'),
      ProductActiveHeaderView = require('./headers/active/view'),
      Config = require('env');

  var showTrans = function (groupId) {
    return Config.env !== 'production' ||
        _.contains(Config.showTransArray, groupId);
  };

  var Layout = BaseView.extend({
    template: require('ldsh!./template'),
    flagProductsReport: false,
    flagProducts: false,
    mdDetailsModel: null,

    serialize: function () {
      var templateParams = {
        isAdm: this.me.isAdm(),
        productsReport: this.productsReport,
        products: this.products,
        me: this.me
      };

      return templateParams;
    },

    beforeRender: function () {
      this.cleanProductList();
      var isAdmin = this.me.isAdm(),
          selectedCompany = this.group.get('selectedCompany'),
          activeProducts = [],
          inactiveProducts = [];

      _.each(this.products.models, function (product) {
        if (product.isActive(isAdmin, selectedCompany) && product.get('active')) {
          if (product.get('name') === 'Transaccionales') {
            activeProducts.splice(1, 0, product);
          } else if (product.get('name') === 'Automation') {
            activeProducts.splice(1, 0, product);
          } else {
            activeProducts.push(product);
          }
        } else if (product.get('name') === 'Automation') {
          inactiveProducts.splice(0, 0, product);
        } else if (product.get('name') === 'Transaccionales') {
          if (showTrans(this.group.get('id'))) {
            inactiveProducts.push(product);
          }
        } else {
          inactiveProducts.push(product);
        }
      }, this);

      if (activeProducts.length > 0) {
        this.insertActiveProductsHeader();
      }

      _.each(activeProducts, function (product) {
        this.insertProductByStatus(product, true);
      }, this);
    },

    insertProductByStatus: function (product, status) {
      var ProductModulesList = this.modules[product.get('name')];

      _.each(ProductModulesList, function (ProductModule) {
        this.insertOneProduct(ProductModule, product, status);
      }, this);
    },

    insertOneProduct: function (ProductModule, product, isActive) {
      var detailsModel = ProductModule.detailsModel,
          productView = new ProductModule.View(this.getDataProduct(ProductModule, detailsModel, product, isActive));

      this.insertView('#product-base-list', productView);
      productView.loadData();
    },

    cleanProductList: function () {
      $('#product-base-list').html('');
    },

    getDataProduct: function (ProductModule, detailsModel, product, isActive) {      
      return {
        productDetailsModel: detailsModel,
        LogoButtonView: ProductModule.LogoButtonView,
        ActivityView: ProductModule.ActivityView,
        StatusView: ProductModule.StatusView,
        InfoView: ProductModule.InfoView,
        selectedCompany: this.group.get('selectedCompany'),
        groupId: this.group.id,
        product: product,
        isAdm: this.me.isAdm(),
        active: isActive,
        productsReport: this.productsReport,
        products: this.products,
        me: this.me,       
        servicePlan: this.group.getService(product.get('name')).type,
      };
    },

    insertActiveProductsHeader: function () {
      var productActiveHeaderView = new ProductActiveHeaderView({isAdm: this.me.isAdm()});
      this.insertView('#product-base-list', productActiveHeaderView);
    }
  });

  module.exports = Layout;
});

